export default __webpack_public_path__ + "static/media/supplements.f1ef37ba.jpg";